import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';
import { cambiarIdioma } from '../i18n';

// Selector de idioma compacto. La elección del usuario persiste y manda sobre tenant/navegador.
export function LangSelector({ compacto = false }) {
  const { i18n } = useTranslation();
  const actual = (i18n.language || 'es').startsWith('en') ? 'en' : 'es';
  return (
    <div className={`lang-selector${compacto ? ' compacto' : ''}`} data-testid="lang-selector">
      <Globe size={14} strokeWidth={2} className="lang-ico" />
      <button
        className={`lang-btn${actual === 'es' ? ' on' : ''}`}
        onClick={() => cambiarIdioma('es')}
        data-testid="lang-es"
      >ES</button>
      <span className="lang-sep">/</span>
      <button
        className={`lang-btn${actual === 'en' ? ' on' : ''}`}
        onClick={() => cambiarIdioma('en')}
        data-testid="lang-en"
      >EN</button>
    </div>
  );
}
